<fieldset class="bordas" [style]="'height: 70px; width: auto'">
    <div>
        <div fxLayout="column" fxFlex="90%">
            <div fxLayout="row" fxLayoutGap="20px">
                <div ngModelGroup="comboColaborador_{{idRandomico}}" fxFlex="100">
                    <combo-funcionario [showDisplayId]="false"
                                       [obrigatorio]="true"
                                       [selecionado]="colaboradorAcao.funcionario"
                                       (valorChange)="onValorChangeColaborador($event)"
                                       [label]="'Colaborador'">
                    </combo-funcionario>
                </div>
            </div>
        </div>

        <div fxLayout="column" fxFlex="10%" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="perfilAcesso.deleta" (click)="deletar()" style="padding: 0px;">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>
</fieldset>